function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z",
    fill: "url(#paint0_linear_1275_3333)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73583 38.8973C12.9708 34.4162 18.2386 31.5 24.1875 31.5C30.0417 31.5 35.2363 34.3241 38.4833 38.6842C34.7591 42.3577 29.6443 44.625 24 44.625C18.4656 44.625 13.4402 42.4451 9.73583 38.8973ZM32.25 19.3125C32.25 23.9724 28.6403 27.75 24.1875 27.75C19.7347 27.75 16.125 23.9724 16.125 19.3125C16.125 14.6526 19.7347 10.875 24.1875 10.875C28.6403 10.875 32.25 14.6526 32.25 19.3125Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_3333",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ABB7",
    style: {
      stopColor: "#A5ABB7",
      stopColor: "color(display-p3 0.6471 0.6706 0.7176)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848B94",
    style: {
      stopColor: "#848B94",
      stopColor: "color(display-p3 0.5176 0.5451 0.5804)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.399c0c6c475b2b97c204d62898090b02.svg";
export { ForwardRef as ReactComponent };